"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const _1 = require(".");
const base_1 = require("./base");
class BlobIterator extends base_1.DataIterator {
    get size() {
        return this.data.size;
    }
    next() {
        return (0, tslib_1.__awaiter)(this, void 0, void 0, function* () {
            if (this.offset >= this.size) {
                return { done: true };
            }
            const chunk = this.data.slice(this.offset, this.offset + this.chunkSize);
            this.offset += chunk.size;
            const value = yield new Response(chunk).arrayBuffer();
            return { done: false, value };
        });
    }
}
function makeDataIterator(data, chunkSize, threshold) {
    if (data instanceof Blob && data.size >= threshold) {
        return new BlobIterator(data, chunkSize);
    }
}
(0, _1.registerDataIteratorFactory)(makeDataIterator);
